<template>
    <div class="account">
        <el-breadcrumb separator-class="el-icon-arrow-right" v-if="postList.headerTitle" style="margin-top: 10px; margin-bottom: 5px">
            <el-breadcrumb-item :to="{ path: '/repertoryList' }">库存列表</el-breadcrumb-item>
            <el-breadcrumb-item>关联产品列表</el-breadcrumb-item>
        </el-breadcrumb>
        <el-row class="main_header">
            <div class="main_header_item" v-if="postList.source_file">
                <el-input
                    v-model="queryParams.source_file"
                    placeholder="请输入源文件"
                    clearable
                    @keyup.enter.native="getList(1)"
                ></el-input>
            </div>
        </el-row>
        <div class="main_list">
            <div class="flex">
                <el-button size="small" plain @click="batchSave" v-if="postList.batchSaveBtn" :loading="save_loading">批量关联</el-button>
                <span style="color: red; font-size: 13px">
                    &nbsp;&nbsp;&nbsp;&nbsp;注意：批量关联只对当前分页的选中产品有效，请勿跨分页操作
                </span>
                <div class="main_header_btns">
                    <el-button type="primary" size="small" @click="getList(1)" v-if="postList.searchBtn">搜索</el-button>
                    <el-button size="small" type="primary" plain @click="reset" v-if="postList.resetBtn">重置</el-button>
                    <draggableList :draggable="draggable" @isErrShow="onSetFieldDone" v-if="postList.setBtn"></draggableList>
                </div>
            </div>
            <el-table
                :data="tableData"
                border
                ref="tableDataRef"
                :max-height="this.$tableHeight"
                class="commodity_stock_product"
                @header-dragend="changeColWidth"
                v-loading="loading"
                element-loading-text="拼命加载中"
                element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(255, 255, 255, 0.8)"
                style="width: 100%"
            >
                <el-table-column label="关联产品" width="360">
                    <template slot-scope="scope" style="height: 100%">
                        <vDropdown
                            style="width: 100%"
                            :initFromLocalData="productDropData"
                            :model_key="scope.row['rid']"
                            model_name="请选择关联产品"
                            @onDropChange="onDropChange1"
                            :model_value_default="formData[scope.row['rid']] || ''"
                        ></vDropdown>
                    </template>
                </el-table-column>
                <template v-for="(item, index) in colData">
                    <el-table-column
                        :key="index"
                        :prop="item.prop"
                        :label="item.title"
                        :min-width="item.width"
                        :sortable="item.sort"
                        align="left"
                        show-overflow-tooltip
                        v-if="colData[index].is_show"
                    >
                        <template slot-scope="scope" style="height: 100%">
                            <div v-if="in_array(item.prop, ['xxx'])">
                                <el-link type="primary" @click="toDetail(scope.row, item.prop)" style="font-size: 11px"
                                    >{{ scope.row[item.prop] }}
                                </el-link>
                            </div>
                            <div v-else>
                                <span> {{ scope.row[item.prop] }} </span>
                            </div>
                        </template>
                    </el-table-column>
                </template>

                <!-- <el-table-column label="操作" width="80">
                    <template slot-scope="scope" style="height: 100%">
                        <el-tooltip class="item" effect="dark" content="保存" placement="top-start">
                            <i class="el-icon-s-claim" @click="save(scope.row)"></i>
                        </el-tooltip>
                    </template>
                </el-table-column> -->
            </el-table>
            <div class="pagination">
                <el-pagination
                    background
                    layout="total,prev, pager, next, sizes, jumper"
                    @current-change="currentChange"
                    @size-change="sizeChange"
                    :page-sizes="[10, 25, 50, 75, 100]"
                    :current-page="queryParams.page"
                    :page-size="queryParams.row"
                    :total="total"
                ></el-pagination>
            </div>
        </div>
    </div>
</template>
<script>
import { onReSize, onSearch, in_array } from '../../../../../js/common';
import draggableList from '../../../../common/Drawer.vue';

export default {
    inject: ['reload'],
    //注册draggable组件
    components: {
        draggableList
    },
    name: 'stockProductListComponent',
    data() {
        return {
            draggable: {
                data_name: 'commodity_stock_product'
            },
            save_loading: false,
            loading: true,
            tableData: [],
            colData: [],
            total: 0,
            // sort: '', //排序参数
            // data_name: '', //排序参数
            queryParams: {},
            productDropData: [],
            formData: {}
        };
    },
    props: {
        postList: {
            type: Object
        }
    },
    beforeMount() {
        this.recoveryQueryParams('page');
        this.initProductDropData();
    },
    mounted() {
        this.$nextTick(() => {
            this.selectedColData(); //筛选列
            this.recoveryQueryParams();
            if (this.postList.params) {
                //如果详情列表需要搜索参数 重置按钮放出来 注意 传来的id不可被重置掉
                this.queryParams.row = 10;
                // 填入相应的参数，调用getList(0);
            } else {
                this.getList(0); //获取列表
            }
        });
    },
    methods: {
        in_array,
        initProductDropData() {
            this.$api['dropdownProducts']({ is_all: true, type_code: [11, 91] })
                .then((res) => {
                    this.productDropData = [];
                    res.data.forEach((item) => {
                        this.productDropData.push({
                            value: item['rid'],
                            label: item['name']
                        });
                    });
                })
                .catch((error) => {});
        },
        //跳转详情
        toDetail(row, prop) {},
        initQueryParams() {
            this.queryParams = {
                page: 1,
                row: 25,
                is_export: 0,
                source_file: ''
            };
            this.saveQueryParams();
        },
        onDropChange(key, value) {
            this.queryParams[key] = value;
        },
        onDropChange1(key, value) {
            this.formData[key] = value;
        },
        saveQueryParams() {
            if (!this.postList.params) {
                localStorage.setItem('commodity_stock_product_params', JSON.stringify(this.queryParams));
            }
        },
        // 分页参数需要在beforeMount初始化，先兼容下
        recoveryQueryParams(type = 'common') {
            //详情内调用不用本地存储的params
            if (!this.postList.params) {
                //列表页面调用 优先取本地存储
                const queryParams = JSON.parse(localStorage.getItem('commodity_stock_product_params'));
                if (queryParams) {
                    if (type == 'common') {
                        this.queryParams = queryParams;
                    } else {
                        this.queryParams.page = queryParams.page || 1;
                        this.queryParams.row = queryParams.row || 25;
                    }
                } else {
                    this.initQueryParams();
                }
            }
        },
        //子组件更新完毕
        onSetFieldDone(data) {
            //刷新下页面
            this.reload();
        },
        //列宽改变事件
        changeColWidth(nw, ow, col, evt) {
            onReSize('commodity_stock_product', this, 1);
        },
        //筛选列
        selectedColData() {
            this.colData = JSON.parse(localStorage.getItem('dataList')).commodity_stock_product;
        },
        // 获取列表 0-非搜索 1-搜索 2-下载
        getList(search_type = 0) {
            onSearch(search_type, this, 'stockProductList');
        },
        currentChange(page) {
            this.queryParams.page = page;
            this.saveQueryParams();
            this.getList(0);
        },
        sizeChange(row) {
            this.queryParams.row = row;
            this.saveQueryParams();
            this.getList(0);
        },
        // 保存
        save(row) {
            if (this.formData[row.rid]) {
            } else {
            }
        },
        // 批量保存
        batchSave() {
            this.save_loading = true;
            var saveData = [];
            this.tableData.forEach((item) => {
                if (this.formData[item.rid]) {
                    saveData.push({
                        product_rid: this.formData[item.rid],
                        source_entity_account_rid: item.source_account_rid,
                        source_product_code: item.source_product_code,
                        source_product_name: item.source_product_name,
                        source_product_specification: item.source_product_specification
                    });
                }
            });

            if (saveData.length == 0) {
                this.save_loading = false;
                this.$message.error('请至少选择一条数据');
                return false;
            }

            this.$api['productSourceBatchSave'](saveData)
                .then((res) => {
                    this.save_loading = false;
                    this.reload();
                })
                .catch((error) => {
                    this.save_loading = false;
                });
        },
        reset() {
            this.initQueryParams();
            this.getList();
        }
    }
};
</script>
<style lang="scss" scoped>
</style>